import classNames from 'classnames';
import { FlexContainer, Txt } from 'components';
import styles from './DepositLinked.module.scss';

/**
 * DepositLinked
 *
 * @return {JSX.Element}
 */
const DepositLinked = ({ className }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.DepositLinked,
        className,
        DepositLinked.displayName
      )}
      column
      gap
    >
      <Txt bold>Tenants deposit has been paid 🎉</Txt>
      <Txt>Great! You now have the deposit in your possession.</Txt>
      <Txt regular>
        Now, to adhere with compliance regulations, you have 30 days to register
        and protect this deposit in a government approved tenancy deposit scheme
        like TDS.
      </Txt>
      <Txt regular>Using Propa you can protect the deposit in minutes.</Txt>
      <Txt regular>Go to the deposit todos to complete.</Txt>
    </FlexContainer>
  );
};

DepositLinked.displayName = 'DepositLinked';

export default DepositLinked;
